import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withKeys as _withKeys, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_2 = ["accept"]
const _hoisted_3 = {
  key: 0,
  style: {"margin":"-2px","padding":"0"}
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { class: "d-flex flex-row" }
const _hoisted_8 = { style: {"height":"calc(100vh - 19rem)","overflow-y":"auto","min-width":"max-content"} }
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = { style: {"height":"calc(100vh - 19rem)","overflow-y":"auto","flex-grow":"1"} }
const _hoisted_11 = { style: {"max-height":"45vh","overflow-y":"auto"} }
const _hoisted_12 = { style: {"height":"calc(100vh-456px)","overflow-y":"auto"} }
const _hoisted_13 = {
  colspan: "4",
  style: {"background-color":"#ff6b6b"}
}
const _hoisted_14 = {
  colspan: "8",
  style: {"background-color":"#ff6b6b"},
  class: "align-center"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "text-right" }
const _hoisted_31 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ColumnCorrespondence = _resolveComponent("ColumnCorrespondence")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_ImportFECTooltip = _resolveComponent("ImportFECTooltip")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "default_card",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title ? `${_ctx.title} - ${_ctx.titleStep}` : `${_ctx.titleStep}`) + " ", 1),
          (_ctx.convertFec && _ctx.convertFec.totalDebitCredit)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(" Ecritures non équilibrés, écart= " + _ctx.convertFec.totalDebitCredit), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { style: {"height":"calc(100vh - 15rem)","overflow-y":"auto"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "pb-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_v_btn, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previous())),
                    elevation: "0",
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                      _createTextVNode(" Précédent ")
                    ])),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.wizardStep >= 0]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  (_ctx.wizardStep >= -1 && _ctx.wizardStep <= 7)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        disabled: _ctx.disabledNext(),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next())),
                        elevation: "0",
                        loading: _ctx.loadingUpsertAAI,
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                          _createTextVNode(" Suivant ")
                        ])),
                        _: 1
                      }, 8, ["disabled", "loading"]))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.valid())),
                        elevation: "0",
                        disabled: !_ctx.isValid() || _ctx.loadingImport,
                        loading: _ctx.loadingImport,
                        "data-cy": "ImportFEC-valid",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[41] || (_cache[41] = [
                          _createTextVNode("Valider")
                        ])),
                        _: 1
                      }, 8, ["disabled", "loading"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window, {
            modelValue: _ctx.wizardStep,
            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.wizardStep) = $event)),
            touchless: "",
            style: {"height":"calc(100vh - 19rem)","overflow-y":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: -1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      (!_ctx.id)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                label: "Fichier",
                                modelValue: _ctx.fileName,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fileName) = $event)),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$refs.inputUpload.click())),
                                "prepend-icon": "$attach_file",
                                class: "cursor-pointer",
                                style: {"width":"100%","margin-right":"auto","margin-left":"auto"},
                                density: "compact"
                              }, null, 8, ["modelValue"]),
                              _withDirectives(_createElementVNode("input", {
                                ref: "inputUpload",
                                type: "file",
                                accept: _ctx.accept,
                                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
                              }, null, 40, _hoisted_2), [
                                [_vShow, false]
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_v_col, {
                        cols: "12",
                        class: "mt-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, { type: "error" }, {
                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                              _createTextVNode(" Le fichier est vide ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.dataRead && !_ctx.outputData && _ctx.title]
                      ]),
                      _withDirectives(_createVNode(_component_v_col, {
                        cols: "12",
                        class: "mt-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, { type: "error" }, {
                            default: _withCtx(() => _cache[43] || (_cache[43] = [
                              _createTextVNode(" Ce fichier a déjà été importé ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.alreadyImported]
                      ]),
                      _withDirectives(_createVNode(_component_v_col, {
                        cols: "12",
                        class: "mt-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, { type: "error" }, {
                            default: _withCtx(() => _cache[44] || (_cache[44] = [
                              _createTextVNode(" Ce fichier n'est pas au format FEC. Veuillez choisir un autre fichier. ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_alert, { type: "error" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.readingError), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.wrongFormat]
                      ]),
                      (_ctx.dataAvailable)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "12",
                            class: "mt-3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.convertFec.importTitle,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.convertFec.importTitle) = $event)),
                                label: "Nom de l'import",
                                readonly: !_ctx.editable,
                                density: "compact"
                              }, null, 8, ["modelValue", "readonly"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "w-100" }, null, -1)),
                      (_ctx.dataAvailable && !_ctx.payslipOnly)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            cols: "6",
                            class: "mt-3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                modelValue: _ctx.accountingPeriod,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accountingPeriod) = $event)),
                                items: _ctx.accountingPeriods,
                                label: "Exercice comptable",
                                "item-title": _ctx.computeAccountingPeriodText,
                                "item-value": "id",
                                "return-object": "",
                                outlined: "",
                                dense: ""
                              }, null, 8, ["modelValue", "items", "item-title"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "mt-3"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.mode !== 'payslip')
                            ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                key: 0,
                                modelValue: _ctx.keyColumn,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.keyColumn) = $event)),
                                items: _ctx.keyColumns,
                                label: "Colonne écriture",
                                readonly: !_ctx.editable,
                                density: "compact"
                              }, null, 8, ["modelValue", "items", "readonly"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 0,
                    value: 0
                  }, {
                    default: _withCtx(() => [
                      (_ctx.wizardStep > -1)
                        ? (_openBlock(), _createBlock(_component_ColumnCorrespondence, {
                            key: 0,
                            ref: "columnComponent",
                            result: { data: _ctx.outputData.rawData, file: { name: 'fecImport' } },
                            resultIsArray: true,
                            extension: _ctx.extension,
                            actions: _ctx.actions,
                            ruleManager: _ctx.ruleManager,
                            formatColumns: _ctx.formatColumns,
                            columnMapping: _ctx.convertFec.columnMapping,
                            dateVerifWording: 'PieceDate',
                            requireDateVerification: true,
                            validateAccountingDates: true,
                            onColumnsChosen: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onColumnsChosen($event)))
                          }, null, 8, ["result", "extension", "actions", "ruleManager", "formatColumns", "columnMapping"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 1,
                    value: 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            style: {"max-height":"70vh"},
                            class: "px-2 flex-shrink-0 flex-grow-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_switch, {
                                modelValue: _ctx.onlyUndefinedAccountable,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.onlyUndefinedAccountable) = $event)),
                                label: 'Comptes comptables non trouvés uniquement'
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_btn, {
                                class: "force-valid-compte-nums-btn mt-3 mb-4",
                                size: "small",
                                elevation: "0",
                                disabled: _ctx.isForceValidCompteNumsInProgress,
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.forceValidCompteNums())),
                                "data-cy": "ImportFEC-forceValidCompteNumsBtn"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.forceValidCompteNumsBtnLabel) + " ", 1),
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    right: "",
                                    dark: ""
                                  }, {
                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                      _createTextVNode("$fa-angle-double-right")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_v_list, { width: "100%" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, { class: "oss-list-item mb-2" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "d-flex justify-start"
                                          }),
                                          _createVNode(_component_v_col, { cols: "3" }, {
                                            default: _withCtx(() => _cache[47] || (_cache[47] = [
                                              _createTextVNode(" Compte (Fichier) ")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: _ctx.editable ? 4 : 3
                                          }, {
                                            default: _withCtx(() => _cache[48] || (_cache[48] = [
                                              _createTextVNode(" Libellé (Fichier) ")
                                            ])),
                                            _: 1
                                          }, 8, ["cols"]),
                                          _createVNode(_component_v_col, {
                                            cols: _ctx.editable ? 2 : 1,
                                            class: "d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => _cache[49] || (_cache[49] = [
                                              _createTextVNode(" Compte (bobbee) ")
                                            ])),
                                            _: 1
                                          }, 8, ["cols"]),
                                          (!_ctx.editable)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "3",
                                                class: "d-flex justify-center"
                                              }, {
                                                default: _withCtx(() => _cache[50] || (_cache[50] = [
                                                  _createTextVNode(" Libellé (bobbee) ")
                                                ])),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_col, {
                                            cols: 2,
                                            class: "d-flex justify-start"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_virtual_scroll, {
                                    "item-height": 56,
                                    items: _ctx.filteredCompteNums,
                                    class: _normalizeClass(["v-window-1-v-virtual-scroll", {
                                        'v-window-1-v-virtual-scroll--hidden':
                                            _ctx.isForceValidCompteNumsInProgress,
                                    }]),
                                    height: "calc(70vh - 16.5rem)",
                                    bench: "2",
                                    "data-cy": "ImportFEC-window1VirtualScroll"
                                  }, {
                                    default: _withCtx(({ item, index }) => [
                                      _createVNode(_component_v_list_item, {
                                        class: "mb-2",
                                        onClick: ($event: any) => (_ctx.selectedAccountableAccountIndex = index),
                                        style: _normalizeStyle(
                                                index === _ctx.selectedAccountableAccountIndex
                                                    ? 'background: rgba(109, 192, 189, 0.3) !important'
                                                    : ''
                                            ),
                                        rounded: "pill",
                                        border: "sm"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex justify-start"
                                              }, {
                                                default: _withCtx(() => [
                                                  (
                                                            _ctx.isGeneralAccountableAccount(item.name)
                                                        )
                                                    ? (_openBlock(), _createBlock(_component_ImportFECTooltip, {
                                                        key: 0,
                                                        message: "G"
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, { cols: 3 }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.displayNominalAccountableAccount(
                                                                item.name,
                                                            )), 1),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subAccount(
                                                            item.name,
                                                        ), (acc, index) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                      (acc === '0')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 0 "))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(acc), 1))
                                                    ], 64))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: _ctx.editable ? 4 : 3
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.getOriginalDescription(item)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["cols"]),
                                              _createVNode(_component_v_col, {
                                                cols: _ctx.editable ? 2 : 1,
                                                class: "d-flex justify-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.oss360AAName ? item.oss360AAName : ""), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["cols"]),
                                              (!_ctx.editable)
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 0,
                                                    cols: "3",
                                                    class: "d-flex justify-center align-center"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.getOss360AAWording(item)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex justify-start"
                                              }, {
                                                default: _withCtx(() => [
                                                  (item.isGeneral)
                                                    ? (_openBlock(), _createBlock(_component_ImportFECTooltip, {
                                                        key: 0,
                                                        message: "G"
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  (item.fromAFMapping)
                                                    ? (_openBlock(), _createBlock(_component_v_avatar, {
                                                        key: 1,
                                                        color: "secondary",
                                                        class: _normalizeClass(
                                                            item.isGeneral
                                                                ? 'ml-2 text-white'
                                                                : 'text-white'
                                                        ),
                                                        size: "16",
                                                        textContent: 'M'
                                                      }, null, 8, ["class"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex justify-end"
                                              }, {
                                                default: _withCtx(() => [
                                                  (!!item.oss360AAName && item.validated)
                                                    ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                        key: 0,
                                                        color: "primary",
                                                        size: "16",
                                                        icon: "$fa-check-circle",
                                                        class: "mr-1",
                                                        onClick: _withModifiers(($event: any) => (
                                                            _ctx.validateAccountableChoice(item)
                                                        ), ["stop"])
                                                      }, null, 8, ["onClick"]))
                                                    : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                        key: 1,
                                                        icon: "$fa-circle",
                                                        size: "16",
                                                        class: "mr-1",
                                                        onClick: _withModifiers(($event: any) => (
                                                            _ctx.validateAccountableChoice(item)
                                                        ), ["stop"])
                                                      }, null, 8, ["onClick"]))
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick", "style"])
                                    ]),
                                    _: 1
                                  }, 8, ["items", "class"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (
                                _ctx.editable &&
                                _ctx.selectedAccountableAccount &&
                                !_ctx.selectedAccountableAccount.fromAFMapping
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                class: "d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0",
                                height: "100%"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[51] || (_cache[51] = [
                                      _createTextVNode("$fa-arrow-left")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                                _ctx.editable &&
                                _ctx.selectedAccountableAccount &&
                                !_ctx.selectedAccountableAccount.fromAFMapping
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                class: "px-2 align-self-center flex-shrink-0 flex-grow-1",
                                style: {"max-height":"59vh"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      (_ctx.selectedAccountableAccount?.oss360AAName?.startsWith('164'))
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "4",
                                            class: "pe-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select_filled, {
                                                modelValue: _ctx.selectedAccountableAccount.tagType,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedAccountableAccount.tagType) = $event)),
                                                items: _ctx.tagTypes,
                                                disabled: _ctx.selectedAccountableAccount.disabledTag,
                                                density: "compact",
                                                "item-title": "text"
                                              }, null, 8, ["modelValue", "items", "disabled"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          (_ctx.selectedAccountableAccount)
                                            ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                key: 0,
                                                modelValue: _ctx.selectedAccountableAccount.tag,
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedAccountableAccount.tag) = $event)),
                                                outlined: "",
                                                disabled: 
                                            _ctx.selectedAccountableAccount.disabledTag ||
                                            !_ctx.selectedAccountableAccount.tagType
                                        ,
                                                density: "compact"
                                              }, null, 8, ["modelValue", "disabled"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (
                                        _ctx.showMoreAccountableAccount = !_ctx.showMoreAccountableAccount
                                    )),
                                        elevation: "0",
                                        class: "d-flex my-2",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Montrer " + _toDisplayString(_ctx.showMoreAccountableAccount ? "moins" : "plus") + " de comptes comptables ", 1),
                                          _createVNode(_component_v_icon, { location: "end" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.showMoreAccountableAccount ? "$fa-minus" : "$fa-plus"), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, { style: {"max-height":"calc(59vh - 8rem)","overflow-y":"auto","width":"100%"} }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAccountableAccounts, (acc, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: index,
                                              class: "my-1",
                                              style: _normalizeStyle(
                                            _ctx.selectedAccountableAccount.oss360AAName === acc.name
                                                ? 'background: rgba(109, 192, 189, 0.3) !important'
                                                : ''
                                        ),
                                              onClick: ($event: any) => (_ctx.setAccountableAccount(acc.name)),
                                              border: "sm",
                                              rounded: "pill"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    (acc.subAccountableAccountOf)
                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                          key: 0,
                                                          cols: "2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => _cache[52] || (_cache[52] = [
                                                                _createTextVNode("$subdirectory_arrow_right")
                                                              ])),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_col, {
                                                          key: 1,
                                                          cols: "2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(acc.displayName || acc.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)),
                                                    _createVNode(_component_v_col, { cols: "10" }, {
                                                      default: _withCtx(() => [
                                                        (acc.original)
                                                          ? (_openBlock(), _createBlock(_component_ImportFECTooltip, {
                                                              key: 0,
                                                              message: "O"
                                                            }))
                                                          : (!acc.id)
                                                            ? (_openBlock(), _createBlock(_component_ImportFECTooltip, {
                                                                key: 1,
                                                                message: "N"
                                                              }))
                                                            : (_openBlock(), _createBlock(_component_ImportFECTooltip, {
                                                                key: 2,
                                                                message: "E"
                                                              })),
                                                        _createTextVNode(" " + _toDisplayString(acc.description), 1),
                                                        (acc.original)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (Compte d'origine)"))
                                                          : _createCommentVNode("", true),
                                                        (!acc.original && !acc.id)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (Nouveau compte)"))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["style", "onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                                _ctx.selectedAccountableAccount &&
                                _ctx.selectedAccountableAccount.fromAFMapping
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 2,
                                class: "px-2 align-self-center flex-shrink-0 flex-grow-1",
                                style: {"max-height":"50vh","overflow-y":"auto"}
                              }, {
                                default: _withCtx(() => [
                                  _cache[53] || (_cache[53] = _createElementVNode("div", null, " Compte comptable bobbee à partir de la table de correspondance du cabinet ", -1)),
                                  _createVNode(_component_v_list, { style: {"max-height":"40vh","overflow-y":"auto"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        class: "oss-list-item",
                                        style: 'background: rgba(109, 192, 189, 0.3) !important'
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "2" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.selectedAccountableAccount.oss360AAName || ""), 1)
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { cols: "10" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.selectedOSS360AA.description), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 2,
                    value: 2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_v_tabs, {
                            modelValue: _ctx.journalCodeSelected,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.journalCodeSelected) = $event)),
                            direction: "vertical"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, index) => {
                                return (_openBlock(), _createBlock(_component_v_tab, {
                                  value: index,
                                  class: "d-flex justify-start",
                                  style: {"border-radius":"6px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_badge, {
                                      color: "red",
                                      content: _ctx.getAAKeyWithoutTypeCount(log),
                                      bordered: "",
                                      "model-value": !!_ctx.getAAKeyWithoutTypeCount(log)
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_avatar, {
                                          color: 
                                                _ctx.journalCodeSelected === index ? 'secondary' : 'grey'
                                            ,
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(log.shortName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color"])
                                      ]),
                                      _: 2
                                    }, 1032, ["content", "model-value"]),
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(log.type ? _ctx.$t("accountingItem.type.") + log.type : log.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_v_tabs_window, {
                            modelValue: _ctx.journalCodeSelected,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.journalCodeSelected) = $event)),
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, index) => {
                                return (_openBlock(), _createBlock(_component_v_window_item, {
                                  style: {"background":"#fff"},
                                  value: index
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          class: "d-flex align-center justify-start h6 pa-3",
                                          style: {"background":"#fff","border-radius":"6px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                              modelValue: _ctx.onlyUndefinedTypes,
                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.onlyUndefinedTypes) = $event)),
                                              label: 'Non affectés',
                                              "hide-details": "",
                                              class: "mt-0"
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_v_switch, {
                                              modelValue: log.import,
                                              "onUpdate:modelValue": ($event: any) => ((log.import) = $event),
                                              label: 'Importer le journal',
                                              "hide-details": "",
                                              class: "pl-2 mt-0"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                            _withDirectives(_createVNode(_component_v_text_field_filled, {
                                              modelValue: log.importName,
                                              "onUpdate:modelValue": ($event: any) => ((log.importName) = $event),
                                              label: "Nom de journal",
                                              outlined: "",
                                              "hide-details": "",
                                              class: "pl-2 mt-0",
                                              density: "compact"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]), [
                                              [_vShow, log.import]
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          class: "d-flex align-center justify-end pa-3",
                                          style: {"background":"#fff","border-radius":"6px"}
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_component_v_chip_group, {
                                              modelValue: log.selectedTypes,
                                              "onUpdate:modelValue": [($event: any) => ((log.selectedTypes) = $event), ($event: any) => (_ctx.onLogTypesChanged(log))],
                                              multiple: "",
                                              mandatory: "",
                                              "selected-class": "primary text-white",
                                              key: 'selectedTypes' + index + _ctx.refreshKey
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.types, (type, i) => {
                                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                                    key: type,
                                                    value: i,
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.$t("accountingItem.type." + type)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "px-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list, {
                                              class: "ma-0 pa-0",
                                              style: {"background":"#fff"}
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.aaKeys, (aaKey, index) => {
                                                  return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                                                    key: index,
                                                    class: "my-2 pa-2",
                                                    "model-value": index
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_col, {
                                                            cols: "12",
                                                            class: "d-flex align-center justify-start subtitle-1"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(aaKey.transactions.length +
                                                                " écriture(s)") + " ", 1),
                                                              _createVNode(_component_v_spacer),
                                                              (aaKey.possibleTypes.length)
                                                                ? (_openBlock(), _createBlock(_component_v_chip_group, {
                                                                    modelValue: aaKey.type,
                                                                    "onUpdate:modelValue": [
                                                                      ($event: any) => ((aaKey.type) = $event),
                                                                      _cache[17] || (_cache[17] = ($event: any) => (_ctx.refreshKey++))
                                                                    ],
                                                                    key: 
                                                                    'keyTypes' + index + _ctx.refreshKey
                                                                ,
                                                                    "selected-class": "primary text-white"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aaKey.possibleTypes, (type, j) => {
                                                                        return _withDirectives((_openBlock(), _createBlock(_component_v_chip, {
                                                                          key: type.type,
                                                                          value: j,
                                                                          size: "small"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.$t(
                                                                            "accountingItem.type." +
                                                                                type.type,
                                                                        )), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["value"])), [
                                                                          [_vShow, !type.disabled]
                                                                        ])
                                                                      }), 128))
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                                                : (_openBlock(), _createBlock(_component_v_chip, {
                                                                    key: 1,
                                                                    color: "orange",
                                                                    size: "small"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(_ctx.$t(
                                                                        "accountingItem.type." +
                                                                            "MISCELLANEOUS_OPERATION",
                                                                    )), 1)
                                                                    ]),
                                                                    _: 1
                                                                  }))
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_component_v_col, { cols: "12" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_divider)
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_v_col, {
                                                            cols: "12",
                                                            class: "outline",
                                                            onClick: _withModifiers(($event: any) => (
                                                                aaKey.showDetails =
                                                                    !aaKey.showDetails
                                                            ), ["stop"])
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(aaKey.showDetails
                                                                    ? "$fa-chevron-down"
                                                                    : "$fa-chevron-up"), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createTextVNode(" " + _toDisplayString(aaKey.name), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["onClick"]),
                                                          (aaKey.showDetails)
                                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                                key: 0,
                                                                cols: "12",
                                                                class: "outline"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_divider),
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aaKey.transactions, (transaction, index) => {
                                                                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(transaction.wording), 1))
                                                                  }), 128))
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["model-value"])), [
                                                    [_vShow, 
                                                        aaKey.type === undefined ||
                                                        !_ctx.onlyUndefinedTypes
                                                    ]
                                                  ])
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 3,
                    value: 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "px-2 flex-shrink-0 flex-grow-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, {
                                width: "100%",
                                style: {"max-height":"50vh","overflow-y":"auto"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, { class: "oss-list-item my-1" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => _cache[54] || (_cache[54] = [
                                              _createTextVNode(" Compte banque du FEC ")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                            default: _withCtx(() => _cache[55] || (_cache[55] = [
                                              _createTextVNode(" Compte banque bobbee ")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "1" }),
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "d-flex justify-end"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankAccounts, (bankAccount, index) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: index,
                                      class: "my-1",
                                      onClick: ($event: any) => (_ctx.bankSelected = index),
                                      style: _normalizeStyle(
                                        index === _ctx.bankSelected
                                            ? 'background: rgba(109, 192, 189, 0.3) !important'
                                            : ''
                                    )
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(bankAccount.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(bankAccount ? bankAccount.outName : ""), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, { cols: "1" }, {
                                              default: _withCtx(() => [
                                                (bankAccount.outName)
                                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                                      key: 0,
                                                      color: "primary",
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(bankAccount.id ? "$fa-database" : "$fa-plus"), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, {
                                              cols: "1",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                (!!bankAccount.id)
                                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                                      key: 0,
                                                      color: "primary"
                                                    }, {
                                                      default: _withCtx(() => _cache[56] || (_cache[56] = [
                                                        _createTextVNode(" $fa-check-circle ")
                                                      ])),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "style"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.editable)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                class: "d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0",
                                height: "100%"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                                      _createTextVNode("$fa-arrow-left")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.editable)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "3",
                                class: "px-2 flex-shrink-0 flex-grow-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, {
                                    width: "100%",
                                    style: {"max-height":"50vh","overflow-y":"auto"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyBankAccounts, (bankAccount, index) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: index,
                                          class: "oss-list-item my-1",
                                          onClick: ($event: any) => {
                                        _ctx.bankAccounts[_ctx.bankSelected].id = bankAccount.id;
                                        _ctx.bankAccounts[_ctx.bankSelected].outName = bankAccount.name;
                                        _ctx.bankAccounts[_ctx.bankSelected].lastDate =
                                            bankAccount.startAuthorizedDate;
                                    }
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_avatar, {
                                                      color: "primary lighten-2",
                                                      class: "text-white",
                                                      size: "16",
                                                      "v-text": bankAccount.id ? 'E' : 'N'
                                                    }, null, 8, ["v-text"]),
                                                    _createTextVNode(" " + _toDisplayString((bankAccount.bank
                                                    ? bankAccount.bank.name + " - "
                                                    : "") + bankAccount.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "pt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field_filled, {
                                            modelValue: _ctx.newBankName,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newBankName) = $event)),
                                            label: "Nouvelle Banque",
                                            outlined: "",
                                            density: "compact"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "d-flex align-center justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: "$fa-plus-circle",
                                            color: "primary",
                                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.createNewBank())),
                                            size: "small"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 4,
                    value: 4
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "7",
                            class: "px-2 flex-shrink-0 flex-grow-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, { width: "100%" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, { class: "oss-list-item my-1" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                                              _createTextVNode(" Nom affiché dans le FEC ")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => _cache[59] || (_cache[59] = [
                                              _createTextVNode(" Nom enregistré chez bobbee ")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "1" }),
                                          _createVNode(_component_v_col, { cols: "1" })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_v_list, {
                                  width: "100%",
                                  style: {"height":"calc(100vh-400px)"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: index,
                                        class: "my-1",
                                        onClick: ($event: any) => (_ctx.setUserSelected(index)),
                                        style: _normalizeStyle(
                                            index === _ctx.userSelected
                                                ? 'background: rgba(109, 192, 189, 0.3) !important'
                                                : ''
                                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(user.key || user.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.getUserDisplayName(user)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, { cols: "1" }, {
                                                default: _withCtx(() => [
                                                  (user.firstname)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 0,
                                                        color: "primary",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(user.id ? "$fa-database" : "$fa-plus"), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex justify-end"
                                              }, {
                                                default: _withCtx(() => [
                                                  (!!user.lastname)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 0,
                                                        color: "primary"
                                                      }, {
                                                        default: _withCtx(() => _cache[60] || (_cache[60] = [
                                                          _createTextVNode(" $fa-check-circle ")
                                                        ])),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick", "style"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          (_ctx.editable)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                class: "d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0",
                                height: "100%"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[61] || (_cache[61] = [
                                      _createTextVNode("$fa-arrow-left")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.editable)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "4",
                                class: "px-2 flex-shrink-0 flex-grow-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "pt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { class: "px-1" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field_filled, {
                                            modelValue: _ctx.newUser.firstname,
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newUser.firstname) = $event)),
                                            label: "Prénom",
                                            outlined: "",
                                            "hide-details": "",
                                            onKeyup: _cache[22] || (_cache[22] = _withKeys(($event: any) => (
                                            _ctx.newUser && _ctx.newUser.firstname && _ctx.newUser.lastname
                                                ? _ctx.createUser()
                                                : null
                                        ), ["enter"])),
                                            density: "compact"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { class: "px-1" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field_filled, {
                                            modelValue: _ctx.newUser.lastname,
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newUser.lastname) = $event)),
                                            label: "Nom",
                                            outlined: "",
                                            "hide-details": "",
                                            onKeyup: _cache[24] || (_cache[24] = _withKeys(($event: any) => (
                                            _ctx.newUser && _ctx.newUser.firstname && _ctx.newUser.lastname
                                                ? _ctx.createUser()
                                                : null
                                        ), ["enter"])),
                                            density: "compact"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "d-flex align-center justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: "$fa-plus-circle",
                                            color: "primary",
                                            size: "small",
                                            onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.createUser()), ["stop"]))
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_v_list, { width: "100%" }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCompanyUsers, (user, index) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: index,
                                            class: "my-1",
                                            onClick: ($event: any) => (_ctx.addUser(user))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.getUserDisplayName(user)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 5,
                    value: 5
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "5",
                            class: "px-2 flex-shrink-0 flex-grow-1",
                            style: {"max-height":"60vh","overflow-y":"auto"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                class: "mt-4",
                                size: "small",
                                elevation: "0",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.autoFillCompany())),
                                disabled: !_ctx.editable
                              }, {
                                default: _withCtx(() => [
                                  _cache[63] || (_cache[63] = _createTextVNode(" Compléter automatiquement ")),
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    right: "",
                                    dark: ""
                                  }, {
                                    default: _withCtx(() => _cache[62] || (_cache[62] = [
                                      _createTextVNode("$fa-angle-double-right")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              (_ctx.companies.length)
                                ? (_openBlock(), _createBlock(_component_v_list, {
                                    key: 0,
                                    width: "100%",
                                    style: {"max-height":"50vh","overflow-y":"auto"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        class: "my-1",
                                        border: "sm",
                                        rounded: "pill"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => _cache[64] || (_cache[64] = [
                                                  _createTextVNode(" Nom affiché dans le FEC ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                default: _withCtx(() => _cache[65] || (_cache[65] = [
                                                  _createTextVNode(" Nom enregistré chez bobbee ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { cols: "2" })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company, index) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: index,
                                          class: "my-1",
                                          onClick: ($event: any) => (_ctx.compCompaniesSelected = index),
                                          style: _normalizeStyle(
                                        index === _ctx.compCompaniesSelected
                                            ? 'background: rgba(109, 192, 189, 0.3) !important'
                                            : ''
                                    ),
                                          border: "sm",
                                          rounded: "pill"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(company.key || company.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(company && company.outName ? company.outName : ""), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, { cols: "1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_tooltip, { location: "start" }, {
                                                      activator: _withCtx(({ props }) => [
                                                        (company.outName)
                                                          ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
                                                              key: 0,
                                                              color: "primary",
                                                              size: "small",
                                                              ref_for: true
                                                            }, props), {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(company.id ? "$fa-database" : "$fa-plus"), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1040))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", null, _toDisplayString(company.id
                                                        ? "Société existante"
                                                        : "Société créée avec l'import"), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, {
                                                  cols: "1",
                                                  class: "d-flex justify-end"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (company.outName && company.outName)
                                                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                                          default: _withCtx(() => _cache[66] || (_cache[66] = [
                                                            _createTextVNode(" $fa-check-circle ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "style"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          (_ctx.editable)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                class: "d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0",
                                height: "100%"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[67] || (_cache[67] = [
                                      _createTextVNode("$fa-arrow-left")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.editable)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "6",
                                class: "px-2 flex-shrink-0 flex-grow-1"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.wizardStep === 5)
                                    ? (_openBlock(), _createBlock(_component_CompaniesTable, {
                                        showGenericCompany: _ctx.companyType.supplier,
                                        showSupplierCompanies: _ctx.companyType.supplier,
                                        showConsumerCompanies: _ctx.companyType.customer,
                                        showCustomerCompanies: _ctx.companyType.customer,
                                        showExistingCompanies: false,
                                        parentCompanyId: _ctx.companyId,
                                        company: 
                                    _ctx.compCompaniesSelected >= 0 &&
                                    _ctx.compCompaniesSelected < _ctx.companies.length
                                        ? _ctx.companies[_ctx.compCompaniesSelected].name
                                        : ''
                                ,
                                        wizardMode: true,
                                        onSelectCompany: _cache[27] || (_cache[27] = ($event: any) => (_ctx.setThirdParty($event))),
                                        key: _ctx.wizardStep
                                      }, null, 8, ["showGenericCompany", "showSupplierCompanies", "showConsumerCompanies", "showCustomerCompanies", "parentCompanyId", "company"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 6,
                    value: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "py-3",
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-2 d-flex justify-center align-center"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.status), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-2 d-flex justify-center align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_switch, {
                                modelValue: _ctx.onlyError,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.onlyError) = $event)),
                                "hide-details": "",
                                label: 'Erreurs uniquement'
                              }, null, 8, ["modelValue"]),
                              (_ctx.containsDateDifferenceErrors)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.correctDateDifferenceErrors())),
                                    elevation: "0",
                                    class: "ml-2",
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => _cache[68] || (_cache[68] = [
                                      _createTextVNode(" Corriger ")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-2 justify-center align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_switch, {
                                modelValue: _ctx.onlyWarning,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.onlyWarning) = $event)),
                                "hide-details": "",
                                label: 'Alertes uniquement'
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "px-2 justify-center align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_switch, {
                                modelValue: _ctx.onlyAutoLettering,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.onlyAutoLettering) = $event)),
                                "hide-details": "",
                                label: 'Montrer les lettrages auto'
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        class: "pt-3",
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "px-2 justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_data_table, {
                                headers: _ctx.headers,
                                items: _ctx.filteredAccountingItems,
                                class: "table",
                                "fixed-header": "",
                                height: "calc(100vh - 410px)"
                              }, {
                                item: _withCtx((props) => [
                                  (_openBlock(), _createElementBlock("tr", {
                                    key: 'AI_' + props.item.index,
                                    style: {"background":"#ededed"}
                                  }, [
                                    (props.item.errorCount)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("td", _hoisted_13, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.getAccountingItemTitle(props.item)), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_14, [
                                            (
                                                        props.item.availableDates &&
                                                        props.item.availableDates.length
                                                    )
                                              ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                  key: 0,
                                                  modelValue: props.item.selectedDate,
                                                  "onUpdate:modelValue": [($event: any) => ((props.item.selectedDate) = $event), ($event: any) => (
                                                        _ctx.onAccountingItemDateChanged(props.item)
                                                    )],
                                                  items: props.item.availableDates,
                                                  "hide-details": "",
                                                  label: "Date #####",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]))
                                              : _createCommentVNode("", true),
                                            (
                                                        props.item.typeError ||
                                                        props.item.datesAreBeforePeriod
                                                    )
                                              ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                  key: 1,
                                                  modelValue: props.item.type,
                                                  "onUpdate:modelValue": [($event: any) => ((props.item.type) = $event), ($event: any) => (
                                                        _ctx.onAccountingItemTypeChanged(props.item)
                                                    )],
                                                  items: props.item.compatibleTypes,
                                                  "item-title": _ctx.getAccountingItemTypeText,
                                                  "hide-details": "",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 64))
                                      : (_openBlock(), _createElementBlock("td", {
                                          key: 1,
                                          colspan: "12",
                                          style: _normalizeStyle(
                                                props.item.warningCount
                                                    ? 'background-color:orange'
                                                    : ''
                                            )
                                        }, [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.getAccountingItemTitle(props.item)), 1)
                                        ], 4))
                                  ])),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.rows, (row) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: row.index
                                    }, [
                                      _createElementVNode("td", {
                                        class: "text-left",
                                        style: _normalizeStyle(_ctx.getCellStyle(row, 'type'))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.$t("accountingItem.type." + row.type)), 1),
                                        (row.typeError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(row.typeError), 1))
                                          : _createCommentVNode("", true)
                                      ], 4),
                                      _createElementVNode("td", {
                                        class: "text-center",
                                        style: _normalizeStyle(_ctx.getCellStyle(row, 'date'))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(row.date)), 1),
                                        (row.dateError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(row.dateError), 1))
                                          : _createCommentVNode("", true),
                                        (row.dateWarning)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(row.dateWarning), 1))
                                          : _createCommentVNode("", true)
                                      ], 4),
                                      _createElementVNode("td", {
                                        class: "text-center",
                                        style: _normalizeStyle(_ctx.getCellStyle(row, 'accountableAccount'))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(row.accountableAccount), 1),
                                        (row.accountableAccountError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(row.accountableAccountError), 1))
                                          : _createCommentVNode("", true),
                                        (row.accountableAccountWarning)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(row.accountableAccountWarning), 1))
                                          : _createCommentVNode("", true)
                                      ], 4),
                                      _createElementVNode("td", {
                                        class: "text-left",
                                        style: _normalizeStyle(_ctx.getCellStyle(row, 'thirdParty'))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(row.thirdParty ? row.thirdParty : ""), 1),
                                        (row.thirdPartyError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(row.thirdPartyError), 1))
                                          : _createCommentVNode("", true)
                                      ], 4),
                                      _createElementVNode("td", {
                                        class: "text-left",
                                        style: _normalizeStyle(_ctx.getCellStyle(row, 'wording'))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(row.wording), 1),
                                        (row.wordingError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(row.wordingError), 1))
                                          : _createCommentVNode("", true)
                                      ], 4),
                                      _createElementVNode("td", {
                                        class: "text-right",
                                        style: _normalizeStyle(_ctx.getCellStyle(row, 'debit'))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.getRowDebit(row)), 1),
                                        (row.debitError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(row.debitError), 1))
                                          : _createCommentVNode("", true)
                                      ], 4),
                                      _createElementVNode("td", {
                                        class: "text-right",
                                        style: _normalizeStyle(_ctx.getCellStyle(row, 'credit'))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.getRowCredit(row)), 1),
                                        (row.creditError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(row.creditError), 1))
                                          : _createCommentVNode("", true)
                                      ], 4),
                                      _createElementVNode("td", {
                                        class: "text-center",
                                        style: _normalizeStyle(_ctx.getCellStyle(row, 'lettering'))
                                      }, [
                                        _createElementVNode("div", null, _toDisplayString(row.lettering || ""), 1),
                                        (row.letteringError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(row.letteringError), 1))
                                          : _createCommentVNode("", true),
                                        (row.letteringWarning)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(row.letteringWarning), 1))
                                          : _createCommentVNode("", true)
                                      ], 4),
                                      _createElementVNode("td", _hoisted_26, [
                                        _createElementVNode("div", null, [
                                          (row.reconciliation)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                  _createTextVNode("$check_circle")
                                                ])),
                                                _: 1
                                              }))
                                            : (row.reconciliationId)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(row.reconciliationId), 1))
                                              : _createCommentVNode("", true)
                                        ]),
                                        (row.reconciliationError)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(row.reconciliationError), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128)),
                                  (_openBlock(), _createElementBlock("tr", {
                                    key: 'AIT_' + props.item.index
                                  }, [
                                    _cache[70] || (_cache[70] = _createElementVNode("td", {
                                      colspan: "3",
                                      style: {"text-align":"left"}
                                    }, [
                                      _createElementVNode("strong", null, "Différence et totaux")
                                    ], -1)),
                                    _createElementVNode("td", {
                                      class: "text-center",
                                      style: _normalizeStyle(_ctx.getCellStyle(props.item, 'difference'))
                                    }, [
                                      _createElementVNode("strong", null, _toDisplayString(props.item.difference), 1),
                                      (props.item.differenceError)
                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_29, _toDisplayString(props.item.differenceError), 1))
                                        : _createCommentVNode("", true)
                                    ], 4),
                                    _cache[71] || (_cache[71] = _createElementVNode("td", null, null, -1)),
                                    _createElementVNode("td", _hoisted_30, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    props.item.totalDebit,
                                                    undefined,
                                                )), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_31, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    props.item.totalCredit,
                                                    undefined,
                                                )), 1)
                                    ]),
                                    _cache[72] || (_cache[72] = _createElementVNode("td", null, null, -1)),
                                    _cache[73] || (_cache[73] = _createElementVNode("td", null, null, -1))
                                  ]))
                                ]),
                                _: 1
                              }, 8, ["headers", "items"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 7,
                    value: 7
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_GeneralLedger, {
                        generalLedger: _ctx.generalLedger,
                        thirdParty: _ctx.generalLedgerWithThirdParty,
                        onThirdPartyChanged: _ctx.onThirdPartyChanged
                      }, null, 8, ["generalLedger", "thirdParty", "onThirdPartyChanged"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dataAvailable)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 8,
                    value: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => _cache[74] || (_cache[74] = [
                              _createTextVNode(" Nom de l'import ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.convertFec.importTitle,
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.convertFec.importTitle) = $event)),
                                outlined: "",
                                readonly: !_ctx.editable,
                                density: "compact"
                              }, null, 8, ["modelValue", "readonly"])
                            ]),
                            _: 1
                          }),
                          (_ctx.dataAvailable && !_ctx.payslipOnly)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                class: "mt-3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getAccountingPeriodTitle()), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.dataAvailable && !_ctx.payslipOnly)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select_filled, {
                                    modelValue: _ctx.accountingPeriod,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.accountingPeriod) = $event)),
                                    items: _ctx.accountingPeriods,
                                    label: "Exercice comptable",
                                    "item-title": _ctx.computeAccountingPeriodText,
                                    "item-value": "id",
                                    "return-object": "",
                                    density: "compact"
                                  }, null, 8, ["modelValue", "items", "item-title"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.containsCarryForward)
                            ? (_openBlock(), _createBlock(_component_v_switch, {
                                key: 2,
                                modelValue: _ctx.importCarryForward,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.importCarryForward) = $event)),
                                label: "Ajouter les reports à nouveau",
                                outlined: ""
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "align-self-end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_v_btn, {
                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.previous())),
                    elevation: "0",
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[75] || (_cache[75] = [
                      _createTextVNode(" Précédent ")
                    ])),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.wizardStep >= 0]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  (_ctx.wizardStep >= -1 && _ctx.wizardStep <= 7)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        disabled: _ctx.disabledNext(),
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.next())),
                        elevation: "0",
                        loading: _ctx.loadingUpsertAAI,
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[76] || (_cache[76] = [
                          _createTextVNode(" Suivant ")
                        ])),
                        _: 1
                      }, 8, ["disabled", "loading"]))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.valid())),
                        elevation: "0",
                        disabled: !_ctx.isValid() || _ctx.loadingImport,
                        loading: _ctx.loadingImport,
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[77] || (_cache[77] = [
                          _createTextVNode("Valider")
                        ])),
                        _: 1
                      }, 8, ["disabled", "loading"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}